<template>
    <CardPage :section="14" :page="6" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great work! You’ve earned another sticker for completing this activity category.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section14/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section14/complete', true);
            this.$store.set('section14/sticker@earned', true);
        }
    }
};
</script>
